import 'phaser';
import Boot from "./js/scenes/boot";
import Game from "./js/scenes/game";
import Menu from "./js/scenes/menu";
import AwaitLoaderPlugin from "phaser3-rex-plugins/plugins/awaitloader-plugin";
import UIPlugin from "phaser3-rex-plugins/templates/ui/ui-plugin";
import ContainerLitePlugin from "phaser3-rex-plugins/plugins/containerlite-plugin";
import GrayScalePipelinePlugin from "phaser3-rex-plugins/plugins/grayscalepipeline-plugin";
import CanvasInputPlugin from "phaser3-rex-plugins/plugins/canvasinput-plugin";
import {isMobile} from "./js/utils/utils";
import TermsAndPrivacy from "./js/scenes/termsAndPrivacy";
import NameInput from "./js/scenes/nameInput";

const config = {
  global: [{
    key: 'rexAwaitLoader',
    plugin: AwaitLoaderPlugin,
    start: true
  }],
  scale:{
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    parent: "phaser-app",
    width: 720,
    height: 1280,
    zoom: isMobile() ? 2 : 1,
    autoRound: true
  },
  input: {
    activePointers: 2
  },
  type: Phaser.WEBGL,
  transparent: true,
  antialias: true,
  scene: [Boot, Menu, Game, TermsAndPrivacy, NameInput],
  plugins: {
    global: [
      {
        key: 'rexcanvasinputplugin',
        plugin: CanvasInputPlugin,
        start: true
      },
      {
        key: 'rexGrayScalePipeline',
        plugin: GrayScalePipelinePlugin,
        start: true
      },
      {
        key: 'rexContainerLitePlugin',
        plugin: ContainerLitePlugin,
        start: true
      }
    ],
    scene: [{
      key: 'rexUI',
      plugin: UIPlugin,
      mapping: 'rexUI'
    }]
  }
};

const game = new Phaser.Game(config);
